import { get } from "./api";

export const getStaticBySlug = (slug: string) => {
  return get("/api/v1/statics", { slug });
};